import { Controller } from "@hotwired/stimulus"

// solution found here: https://discuss.hotwired.dev/t/how-to-redirect-from-a-form-that-is-inside-a-turbo-frame/4164/2
export default class extends Controller {
  next(event) {
    if (event.detail.success) {
      const fetchResponse = event.detail.fetchResponse

      history.pushState(
        { turbo_frame_history: true },
        "",
        fetchResponse.response.url
      )

      window.Turbo.visit(fetchResponse.response.url)
    }
  }
}
